var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getScreen ? 'm-page-wrapper' : 'd-page-wrapper'},[_c('router-view',{staticClass:"height-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }